import React, { ReactElement, ReactNode } from 'react';

type EtatEntiteProps = {
    marginTop?: boolean;
    children: ReactNode;
    textColor?: string;
};

export function EtatEntite(props: EtatEntiteProps): ReactElement {
    return (
        <div
            style={{ marginTop: props.marginTop ? '0.5rem' : 0, color: props.textColor }}
            className="shadow-sm rounded bg-white p-2 mb-2 d-inline-flex justify-content-around align-items-center max-width"
        >
            {props.children}
        </div>
    );
}
